{
  "PendingInvites": "Pending Invites",
  "delete": "Delete",
  "sendANudge": "send a nudge",
  "NoPendingInvitations": "No pending invitations",
  "InviteTeammate": "Invite a Teammate",
  "InviteTeammateContinued": "(only fellow rebels allowed)",
  "Email": "Email",
  "sendInvite": "Send Invite",

  "InviteTitle": "Choose the role you want to invite",
  "SelectRole": "Select a Role",
  "SelectRoles": "Select role(s)",
  "WorkingOnInnovation": "working on innovation",
  "Supporter": "Supporter",
  "LendingExpertise": "lending expertise",
  "General": "General",
  "NoRole": "no role",
  "InviteViaEmails": "Invite via Emails",
  "InvitePlaceholder": "Add multiple email addresses one at a time",
  "TypeEmail": "Type an email address and press 'Enter'",
  "PersonalizeInvitationMessage": "Personalize your invitation with a message",
  "AddYourMessage": "Add your message",
  "optional": "optional",
  "AddToActiveGroup": "Add to active group (optional)",
  "AddMessage": "This will add them as a member",
  "NewGroup": "new group",
  "AddNameOfGroup": "add name of group",
  "createGroup": "create group",
  "Finish": "Finish",
  "close": "close",
  "send": "send",
  "invites": "invites",
  "SelectRoleFirst": "select role type first",
  "InviteHubAdmin": "To invite a hub admin",
  "ClickHere": "click here.",
  "SubscriptionHeader": "Your Subscription Plan Allows for 3 active groups",
  "SubscriptionMessage": "Upgrade to unlock unlimited active groups",
  "SubscriptionHint": "Hint: you can deactivate other group to make room for this one",
  "Upgrade": "Upgrade",
  "Cancel": "Cancel",
  "InvitesSent": "Invite(s) sent successfully.",
  "IncorrectEmail": "Oh no. You seems to type an incorrect email.",
  "InviteSentWithoutEmail": "Oh no. You seems to send a invite without an email."
}
